export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12079.8bfa2800.jpg";